module.exports = __webpack_public_path__ + "media/images/application/template/30-second-quote/5x2-flatpack-mobile-79fa2d069fd58bc1270a8674b6dbcaf7.png";